<template>
    <v-container fluid>
        <v-card class="elevation-3" :loading="loading">
            <div class="card-title">{{ $t('OldDataTable') }}</div>
            <v-card-title>
                <v-text-field v-model="search" clearable append-icon="mdi-magnify" :label="$t('Search')" single-line hide-details />
            </v-card-title>
            <v-data-table :search="search" :headers="headers" dense :items="result" :items-per-page="20" :footer-props="footerProps">
                <template v-slot:top>
                    <v-btn small class="ma-4 white--text" tile color="primary" @click="open()">
                        {{ $t('Add') }} <v-icon small class="ms-2">mdi-plus</v-icon>
                    </v-btn>
                </template>
                <template v-slot:[`item.surveyId`]="{ item }">
                    {{item.surveyId?surveys.filter(x=>x.id == item.surveyId)[0].nameAr:''}}
                </template>
                <template v-slot:[`item.optionId`]="{ item }">
                    {{allcsatoptions.filter(x=>x.id == item.optionId).length>0?allcsatoptions.filter(x=>x.id == item.optionId)[0].name:''}}
                </template>
                <template v-slot:[`item.filterOptionId`]="{ item }">
                    {{allfilterquestions.length>0 && allfilterquestions[0].options.filter(x=>x.id == item.filterOptionId).length>0?allfilterquestions[0].options.filter(x=>x.id == item.filterOptionId)[0].name:''}}
                </template>
                <template v-slot:[`item.options`]="{ item }">
                    <v-icon color="primary" class="ms-3" @click="editItem(item)"> mdi-pen</v-icon>
                    <v-icon color="error" class="ms-3" @click="deleteItem(item.id)">mdi-trash-can-outline</v-icon>
                </template>
            </v-data-table>
            <v-form ref="OldDataForm" v-model="valid" lazy-validation>
                <CommonDialog v-model="dialog" :fullscreen="false" width="500" :title="title" show-action-toolbar>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field v-model="OldData.quarter" :label="$t('Quarter')" clearable outlined :rules="nameRules" required />
                            </v-col>
                            <v-col cols="12">
                                <v-text-field v-model="OldData.year" :label="$t('Year')" clearable outlined :rules="nameRules" required />
                            </v-col>
                            <v-col cols="12">
                                <v-text-field v-model="OldData.count" :label="$t('Count')" clearable outlined :rules="nameRules" required />
                            </v-col>
                            <v-col cols="12">
                                <v-select v-model="OldData.surveyId" @change="listCSATOptions(OldData.surveyId)" :items="surveys" :label="$t('Survey')" item-text="nameAr" item-value="id" clearable outlined required></v-select>
                            </v-col>
                            <v-col cols="12">
                                <v-select v-if="csatoptions.length>0" v-model="OldData.optionId" :items="csatoptions" :label="$t('Answer')" item-text="name" item-value="id" clearable outlined required></v-select>
                            </v-col>
                            <v-col cols="12">
                                <v-row v-for="q in filterquestions" :key="q.id">
                                    <v-col>
                                        <v-select v-model="OldData.filterOptionId" clearable outlined :items="q.options" :label="q.title" required item-text="name" item-value="id"></v-select>
                                    </v-col>
                                </v-row>

                            </v-col>
                        </v-row>
                    </v-container>

                    <template v-slot:actions>
                        <v-btn v-if="!edit" color="primary" class="white--text" tile :disabled="loading || !OldData.optionId || !OldData.quarter || ! OldData.year || !OldData.count" small @click="save()">
                            {{ $t("Add") }}
                        </v-btn>
                        <v-btn v-if="edit" color="primary" class="white--text" tile :disabled="loading || !OldData.optionId || !OldData.quarter || ! OldData.year || !OldData.count" small @click="update()">
                            {{ $t("Update") }}
                        </v-btn>
                        <v-btn color="error" class="white--text" tile :disabled="loading" small @click="dialog = false; reset()">
                            {{ $t("Cancel") }}
                        </v-btn>
                    </template>
                </CommonDialog>
            </v-form>
        </v-card>
    </v-container>
</template>

<script>
    import CommonDialog from '@/components/controls/CommonDialog'
    import OldDataService from '@/services/OldDataService.js'
    import SurveyService from '@/services/SurveyService'
    import { AnalyticsTypes } from '@/helpers/constants/enumerations.js'

    export default {
        components: {
            CommonDialog
        },

        data() {
            return {
                title: '',
                search: '',
                valid: true,
                loading: false,
                dialog: false,
                surveys:[],
                edit: false,
                selectedItemId: null,
                result: [],
                filterquestions: [],
                csatoptions: [],
                allcsatoptions: [],
                allfilterquestions: [],
                headers: [
                    { text: this.$t('Quarter'), value: 'quarter' },
                    { text: this.$t('Year'), value: 'year' },
                    { text: this.$t('Answer'), value: 'optionId' },
                    { text: this.$t('Count'), value: 'count' },
                    { text: this.$t('FilterAnswer'), value: 'filterOptionId' },
                    { text: this.$t('Survey'), value: 'surveyId' },                  
                    { text: this.$t('Options'), value: 'options', width: '8%' },
                ],
                nameRules: [
                    v => !!v || this.$t('RequiredField')
                ],
                footerProps: {
                    'items-per-page-options': [20, 50, 100],
                    'disable-pagination': false
                },
                OldData: {
                    quarter: null,
                    year: null,
                    count: null,
                    surveyId:null
                }
            }
        },

        created() {
            this.loadOldData()
            this.listAllFilterQuestions()
            this.listAllCSATOptions()
            this.listSurveys()
        },

        methods: {
            listSurveys() {
                this.loading = true
                SurveyService.listSurveys(false).then((res) => {
                    this.surveys = res.data
                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }).finally(() => {
                    this.loading = false
                })
            },
            async listFilterQuestions(surveyId){
                var resp = await SurveyService.listFilterQuestions(AnalyticsTypes.Sakani, surveyId)
                this.filterquestions = []
                if(resp.data.length>0)
                {
                    this.filterquestions.push(resp.data[0])
                }

            },
            async listCSATOptions(surveyId){
                var resp = await SurveyService.listCSATOptions(AnalyticsTypes.Sakani, surveyId)
                this.csatoptions = resp.data
                this.listFilterQuestions(surveyId)
            },
            async listAllFilterQuestions() {
                var resp = await SurveyService.listAllFilterQuestions(AnalyticsTypes.Sakani)
                this.allfilterquestions = []
                if (resp.data.length > 0) {
                    this.allfilterquestions.push(resp.data[0])
                }

            },
            async listAllCSATOptions() {
                var resp = await SurveyService.listAllCSATOptions(AnalyticsTypes.Sakani)
                this.allcsatoptions = resp.data
            },
            loadOldData() {
                this.loading = true
                OldDataService.listOldData().then((res) => {
                    if (res.data) {
                        this.result = res.data
                    }
                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }).finally(() => {
                    this.loading = false
                })
            },

            save() {
                if (this.$refs.OldDataForm.validate()) {
                    OldDataService.addOldData(this.OldData).then((res) => {
                        this.loadOldData()
                        this.reset()
                        this.$refs.OldDataForm.resetValidation()
                    }).catch(() => {
                        this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                    }).finally(() => {
                        this.loading = false
                        this.dialog = false
                    })
                }
            },

            update() {
                if (this.$refs.OldDataForm.validate()) {
                    OldDataService.updateOldData(this.selectedItemId, this.OldData).then((res) => {
                        this.dialog = false
                        this.loadOldData()
                        this.reset()
                    }).catch(() => {
                        this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                    }).finally(() => {
                        this.loading = false
                        this.dialog = false
                    })
                }
            },

            async deleteItem(id) {
                if (await this.$root.$confirm(this.$t('Delete'), this.$t('ConfirmDelete'))) {
                    this.loading = true
                    OldDataService.deleteOldData(id)
                        .then(() => {
                            this.loadOldData()
                        })
                        .catch(() => {
                            this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                        }).finally(() => this.loading = false)
                }
            },

            reset() {
                this.selectedItemId = null
                this.OldData = {
                    quarter: null,
                    year: null,
                    count: null,
                    surveyId: null
                }
                this.csatoptions = []
                this.filterquestions = []
            },

            open() {
                this.reset()
                this.edit = false
                this.selectedItemId = null
                this.$refs.OldDataForm.resetValidation()
                this.title = this.$t('Add')
                this.dialog = true
            },

            editItem(item) {
                this.listCSATOptions(item.surveyId)
                this.edit = true
                this.OldData = item
                this.selectedItemId = item.id
                this.title = this.$t('Edit')
                this.dialog = true
            },
        },
    }
</script>

<style>
</style>